import { lazy } from 'react'

export const RoutinesChangesVariant1 = lazy(
  () => import('./RoutinesChangesVariant1'),
)
